var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('section-one'),_c('section-two'),_c('section-three')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }